export default __webpack_public_path__ + "static/media/mail-sent.8491dc8e.svg";